export const VehicleFuelEnum = {
  Petrol: 'Petrol',
  Diesel: 'Diesel',
  Electric: 'Electric',
  Hybrid: 'Hybrid',
  LPG: 'LPG',
} as const;

export const VehicleTransmissionEnum = {
  Manual: 'Manual',
  Automatic: 'Automatic',
} as const;

export type VehicleFuelEnumType = keyof typeof VehicleFuelEnum;
export type VehicleTransmissionEnumType = keyof typeof VehicleTransmissionEnum;
